
































import { Component, Vue } from "vue-property-decorator";
import { getLocaleCountryCode } from "@/data/enums/i18n";
import { IState } from "@/store";

@Component
export default class BrandLanguageSelector extends Vue {
  // Computed

  public get languages() {
    return this.$_.orderBy(
      (this.$store.state as IState)?.brand?.languages || [],
      ["language"],
      ["asc"]
    );
  }

  public get activeLocaleCode() {
    return this.$store.state?.i18n?.activeLocaleCode;
  }

  public get activeLanguage() {
    return this.$_.find(this.languages, ["code", this.activeLocaleCode])
      ?.language;
  }

  // Methods

  public async setLanguage(code: string) {
    await this.$store.dispatch("i18n/setLanguage", code, { root: true });
    this.$store.dispatch("toast/show", {
      message: this.$t("_.language_changed"),
      position: "is-bottom"
    });
  }

  public getLocaleCountryCode(code: string) {
    return getLocaleCountryCode(code);
  }
}
